import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <p>
          © 2026 TaskMind AI. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;